import { GlobalErrorHandler } from '@one/app/shared/classes/global-error-handler';
import { ErrorHandler, ClassProvider } from '@angular/core';

export const GLOBAL_ERROR_HANDLER_PROVIDER: ClassProvider = {
  provide: ErrorHandler,
  useClass: GlobalErrorHandler,
};
